<template>
  <el-tabs :value="active" @tab-click="handleTabClick">
    <el-tab-pane
      v-for="tab in tabs"
      :label="tab.name"
      :name="tab.id"
      :key="tab.id"
    ></el-tab-pane>
  </el-tabs>
</template>


<script>
import router from "@/router.js";

export default {
  name: "Tabs",
  props: {
    active: String,
    tabs: Array
  },
  methods: {
    handleTabClick: function(tab) {
      router.push(tab.name);
    }
  }
};
</script>
